module.exports = __webpack_public_path__ + "img/chlorineResult_hydrant.e7505feb.svg";